import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useParams,useLocation, } from 'react-router-dom';
import { List, ListItem, ListItemText, ListItemButton, Typography, CircularProgress, Box } from '@mui/material';
import Pagination from '../components/Pagination';
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const params = useParams();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalNotifications, setTotalNotifications] = useState(0); // Toplam görev sayısı
  const limit = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Sayfa başına gösterilecek görev sayısı
  // localStorage'dan kullanıcı bilgisini alıyoruz
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const userId = storedUser?.id; // localStorage'dan çekilen userId
  //const projectId = searchParams.get('projectId'); // URL'den projectId alınır ?projectId=6 gibi
  const projectId = params.projectId || location.pathname.split('/')[2];
  // Bildirimleri backend'den çekme işlemi
  const { t } = useTranslation();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });
  useEffect(() => {
    if (userId && projectId) {
      const fetchNotifications = async () => {
        try {
          console.log('Base URL:', process.env.REACT_APP_API_BASE_URL);
          const response = await api.get(`/api/notifications/user/${userId}?projectId=${projectId}&page=${currentPage}&limit=${limit}`);
          
          // Assuming the response has notifications and totalPages
          setNotifications(response.data.notifications);
          setTotalPages(response.data.totalPages);
          setTotalNotifications(response.data.totalNotifications);
          setLoading(false);
        } catch (error) {
          
          setLoading(false);
        }
      };

      fetchNotifications();
    }
  }, [userId, projectId, currentPage, limit]);


  // Bildirimleri `read` olarak işaretleme
  useEffect(() => {
    const markNotificationsAsRead = async () => {
      try {
        const token = localStorage.getItem('token');
        //const projectId = new URLSearchParams(window.location.search).get('projectId');

        const response = await api.put(
          '/api/notifications/mark-read',
          { projectId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Başarılı olursa okunmamış bildirim sayısını sıfırla
        //setUnreadCount(0);
      } catch (error) {
        
      }
    };

    if (notifications.length > 0) {
      markNotificationsAsRead();
    }
  }, [notifications]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        {t("notifications.title")}
      </Typography>

      {notifications.length === 0 ? (
        <Typography variant="body1">{t("notifications.no_notifications")}</Typography>
      ) : (
        <List>
          {notifications.map((notification) => (
            <ListItem key={notification.id} sx={{ backgroundColor: notification.isRead ? '#f5f5f5' : '#ffffff' }}>
              <ListItemButton
                onClick={() => {
                  if (notification.link) {
                    window.location.href = notification.link; // Bildirimdeki linke yönlendirme
                  }
                }}
              >
                <ListItemText
                  primary={notification.message}
                  secondary={`${t("notifications.type")}: ${notification.type} | ${t("notifications.created_at")}: ${new Date(notification.createdAt).toLocaleString()}`}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}

      <Pagination
        totalItems={totalNotifications}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default Notifications;
